import React from 'react'

interface SingleLineDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const SingleLineDT: React.FC<SingleLineDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M9.18301 16.25H6.24967C5.73301 16.25 5.27467 16.2333 4.86634 16.175C2.67467 15.9333 2.08301 14.9 2.08301 12.0833V7.91667C2.08301 5.1 2.67467 4.06667 4.86634 3.825C5.27467 3.76667 5.73301 3.75 6.24967 3.75H9.13301" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.5166 3.75H13.7499C14.2666 3.75 14.7249 3.76667 15.1333 3.825C17.3249 4.06667 17.9166 5.1 17.9166 7.91667V12.0833C17.9166 14.9 17.3249 15.9333 15.1333 16.175C14.7249 16.2333 14.2666 16.25 13.7499 16.25H12.5166" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.5 1.66602V18.3327" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.2451 10.0007H9.25258" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.91209 10.0007H5.91957" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default SingleLineDT
